module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-base-info-form"
  }, [_c('h6', {
    staticClass: "title"
  }, [_vm._v("公司基本信息\n        "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isAdd),
      expression: "!isAdd"
    }],
    staticStyle: {
      "float": "right",
      "margin-right": "10px"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }],
    attrs: {
      "type": "primary",
      "size": "small",
      "loading": _vm.getTsInfoLoading
    },
    on: {
      "click": _vm.getTsInfo
    }
  }, [_vm._v(_vm._s(_vm.getAndHcLabel))])], 1)]), _vm._v(" "), _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.companyInfo,
      "label-width": "84px"
    }
  }, [_c('div', {
    staticClass: "v-com-form"
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "公司",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled,
      "maxlength": 150
    },
    on: {
      "blur": _vm.companyblur,
      "focus": _vm.companyFocus
    },
    model: {
      value: (_vm.companyInfo.Customer),
      callback: function($$v) {
        _vm.$set(_vm.companyInfo, "Customer", $$v)
      },
      expression: "companyInfo.Customer"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "电话",
      "required": ""
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.companyInfo.Tel),
      callback: function($$v) {
        _vm.$set(_vm.companyInfo, "Tel", $$v)
      },
      expression: "companyInfo.Tel"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属业务经理",
      "required": ""
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }],
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": _vm.selectStaffFn
    }
  }, [_vm._v("选择")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.companyInfo.BusEmployeeName))])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "统一社会信用代码",
      "required": _vm.isRequired
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled,
      "maxlength": 150
    },
    model: {
      value: (_vm.companyInfo.SocialCreditCode),
      callback: function($$v) {
        _vm.$set(_vm.companyInfo, "SocialCreditCode", $$v)
      },
      expression: "companyInfo.SocialCreditCode"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "公司法人",
      "required": _vm.isRequired
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled,
      "maxlength": 150
    },
    model: {
      value: (_vm.companyInfo.Corporation),
      callback: function($$v) {
        _vm.$set(_vm.companyInfo, "Corporation", $$v)
      },
      expression: "companyInfo.Corporation"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "法人身份证号",
      "required": _vm.isRequired
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled,
      "maxlength": 150
    },
    model: {
      value: (_vm.companyInfo.Corporation_IDNumber),
      callback: function($$v) {
        _vm.$set(_vm.companyInfo, "Corporation_IDNumber", $$v)
      },
      expression: "companyInfo.Corporation_IDNumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isComShow),
      expression: "isComShow"
    }],
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "营业执照",
      "required": _vm.isRequired
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.companyInfo.Company_Drawing), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showImgOpt),
        expression: "showImgOpt"
      }],
      staticClass: "el-icon-delete2",
      on: {
        "click": function($event) {
          _vm.delC_Drawing(_vm.companyInfo.Company_Drawing, index)
        }
      }
    })])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showImgOpt),
      expression: "showImgOpt"
    }],
    staticClass: "container",
    attrs: {
      "id": _vm.cdContainerId
    }
  }, [_c('el-button', {
    staticClass: "upload-btn",
    attrs: {
      "id": _vm.cdBtnId,
      "size": "small",
      "icon": "plus"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isComShow),
      expression: "isComShow"
    }],
    staticClass: "viewImgPos",
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "法人身份证",
      "required": _vm.isRequired
    }
  }, [_c('ul', {
    staticClass: "img-list"
  }, _vm._l((_vm.companyInfo.Corporation_Drawing), function(img, index) {
    return _c('li', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": img.Url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "img-mask"
    }, [_c('i', {
      staticClass: "el-icon-view",
      on: {
        "click": function($event) {
          _vm.showImgView(img)
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showImgOpt),
        expression: "showImgOpt"
      }],
      staticClass: "el-icon-delete2",
      on: {
        "click": function($event) {
          _vm.delC_Drawing(_vm.companyInfo.Corporation_Drawing, index)
        }
      }
    })])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showImgOpt),
      expression: "showImgOpt"
    }],
    staticClass: "container",
    attrs: {
      "id": _vm.crpdContainerId
    }
  }, [_c('el-button', {
    staticClass: "upload-btn",
    attrs: {
      "id": _vm.crpdBtnId,
      "size": "small",
      "icon": "plus"
    }
  })], 1)])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('area-select', {
    ref: "areaForm",
    attrs: {
      "label": "公司地址",
      "label-width": "84px",
      "value": _vm.areaInfo,
      "disabled": _vm.disabled,
      "required": ""
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "详细地址",
      "required": ""
    }
  }, [_c('el-input', {
    staticClass: "full-field",
    attrs: {
      "disabled": _vm.disabled,
      "maxlength": 150
    },
    model: {
      value: (_vm.companyInfo.Address),
      callback: function($$v) {
        _vm.$set(_vm.companyInfo, "Address", $$v)
      },
      expression: "companyInfo.Address"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "税号",
      "required": _vm.isRequired
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": _vm.disabled,
      "maxlength": 150
    },
    model: {
      value: (_vm.companyInfo.TaxNumber),
      callback: function($$v) {
        _vm.$set(_vm.companyInfo, "TaxNumber", $$v)
      },
      expression: "companyInfo.TaxNumber"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "数据类型"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.DataType),
      callback: function($$v) {
        _vm.DataType = $$v
      },
      expression: "DataType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("测试")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("正式")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.DataType == 1),
      expression: "DataType==1"
    }],
    attrs: {
      "label": "是否体验"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.IsExperience),
      callback: function($$v) {
        _vm.IsExperience = $$v
      },
      expression: "IsExperience"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("否")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("是")])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.isReadOnly) ? _c('div', {
    staticClass: "v-com-matter"
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectDepartmentVisiable || _vm.imgViewVisiable),
      expression: "selectDepartmentVisiable || imgViewVisiable"
    }],
    staticClass: "agent-info-mask"
  }), _vm._v(" "), _c('el-dialog', {
    staticClass: "img-view",
    attrs: {
      "size": "large",
      "modal": false,
      "show-close": true
    },
    model: {
      value: (_vm.imgViewVisiable),
      callback: function($$v) {
        _vm.imgViewVisiable = $$v
      },
      expression: "imgViewVisiable"
    }
  }, [_c('img', {
    staticClass: "show-img-css",
    attrs: {
      "src": _vm.imgViewSrc,
      "width": "100%",
      "height": "100%"
    }
  })])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1e0c69bb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/agent-base-info/index.vue
// module id = 1408
// module chunks = 1